import { c as _c } from "react/compiler-runtime";
import React from 'react';
const ConsumerNewsletterThankYou = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex-[1_1]"><div className="min-h-[64px] flex items-center"><div className="signup-uppersection"><div className="signup-subtitle">Thank you for signing up!</div></div></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ConsumerNewsletterThankYou;